/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import { parse, stringify } from '@vanillaes/csv'

const COL_TIMESTAMP = 0;

class LogLine {
    constructor(loglinearray) {
        this.logline = loglinearray;
        this.data = []

        this.parseLogLine();
    }

    get Timestamp() {
        return parseFloat(this.logline[COL_TIMESTAMP]);
    }

    parseLogLine() {

        var colom = 1

        for (; colom < this.logline.length;) {
            this.data.push({ x: parseFloat(this.logline[colom]), y: parseFloat(this.logline[colom + 1]), z: parseFloat(this.logline[colom + 2]) });
            colom += 3
        }
    }
}

export default class Lidarlog {
    #parsed;

    constructor(lidarlog) {
        this.lidarlog = lidarlog;
        this.data = [];

        this.#parsed = parse(this.lidarlog);
        this.parseLidarlog();
    }

    parseLidarlog() {
        for (let i = 0; i < this.#parsed.length; i++) {
            this.data.push(new LogLine(this.#parsed[i]));
        }
    }
}